import React from 'react';
import PropTypes from 'prop-types';
import { FaSearch, FaTimes } from 'react-icons/fa';

import TextInput from '../TextInput';
import Button from '../Button';
import { StyledSearchInput } from './searchInput.styled';

const SearchInput = ({ handleSubmit, handleChange, handleReset, value }) => {
  return (
    <StyledSearchInput onSubmit={handleSubmit} value={value}>
      <TextInput
        placeholder="What are you searching for?"
        className="search-input" 
        name="search-input"
        handleChange={handleChange}
        value={value}
      />
      <Button className="control-button control-button__search" type="submit">
        <FaSearch />
      </Button>
      <Button className="control-button control-button__reset" type="reset" handler={handleReset}>
        <FaTimes />
      </Button>
    </StyledSearchInput>
  );
};

SearchInput.propTypes = {
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleReset: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired
};

SearchInput.defaultProps = {
  value: ''
};

export default SearchInput;
